import { MdLocalOffer } from 'react-icons/md'

const formatBRL = (cents: number): string =>
    (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

/**
 * Cupom usado no atendimento (exame, consulta, procedimento): o código e quanto ele
 * abateu, congelado no momento em que foi aplicado. Sem cupom, não renderiza nada.
 */
export default function AppointmentCoupon({
    code,
    amount,
    className = '',
}: {
    code?: string | null
    amount?: number | null
    className?: string
}) {
    if (!code) return null
    return (
        <div className={`flex items-center gap-2 p-3 bg-success/10 rounded-xl min-w-0 ${className}`}>
            <MdLocalOffer className="text-lg text-success shrink-0" />
            <div className="min-w-0">
                <p className="text-xs text-base-content/60">Cupom</p>
                <p className="font-semibold break-words">
                    {code}
                    {amount ? <span className="ml-1 font-normal text-success">-{formatBRL(amount)}</span> : null}
                </p>
            </div>
        </div>
    )
}
